/**
 * Configuración de entorno del panel.
 */

export const API_URL: string = import.meta.env.VITE_API_URL ?? 'http://localhost:3000';

/**
 * Origen del WebSocket de estado en vivo. Se deriva del API salvo que se
 * apunte a otro host, que es lo normal en producción si el WS va por un
 * ingress distinto.
 */
export const WS_URL: string =
  import.meta.env.VITE_WS_URL ??
  API_URL.replace(/^http(s?):\/\//i, (_match, s: string) => `ws${s}://`);
